module.exports = __webpack_public_path__ + "static/img/bingli3.3491c1b5.webp";